import { createWebHashHistory, createRouter } from "vue-router";
import AppLayout from './layout/AppLayout.vue';

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/home',
            component: AppLayout,
            children: [
                {
                    path: '/',
                    name: 'home',
                    component: () => import('./components/blog/Home.vue')
                },
                {
                    path: '/site-settings',
                    name: 'site-settings',
                    component: () => import('./components/blog/Settings.vue')
                },
                {
                    path: '/site-staff',
                    name: 'site-staff',
                    component: () => import('./components/blog/Staff.vue')
                },
                {
                    path: '/site-export',
                    name: 'site-export',
                    component: () => import('./components/blog/Export.vue')
                },
                {
                    path: '/core-connections',
                    name: 'core-connections',
                    component: () => import('./components/blog/CoreConnections.vue')
                },
                {
                    path: '/site-integrations',
                    name: 'site-integrations',
                    component: () => import('./components/blog/Integrations.vue')
                },
                {
                    path: '/site-custom-sending-domain',
                    name: 'site-custom-sending-domain',
                    component: () => import('./components/blog/custom-sending-domain/Setup.vue')
                },
                {
                    path: '/site-custom-sending-domain-verify',
                    name: 'site-custom-sending-domain-verify',
                    component: () => import('./components/blog/custom-sending-domain/Verify.vue')
                },
                {
                    path: '/request-upgrade',
                    component: () => import('./components/blog/RequestPlanUpgrade.vue')
                },
                {
                    path: '/members',
                    name: 'site-members',
                    component: () => import('./components/members/Members.vue')
                },
                {
                    path: '/members-filter/:filterBy/:filterMode/:filterValue',
                    name: 'site-members-filter',
                    component: () => import('./components/members/Members.vue'),
                    props: true,
                },
                {
                    path: '/member-add',
                    name: 'site-member-add',
                    component: () => import('./components/members/MemberAdd.vue')
                },
                {
                    path: '/members-cleanup',
                    name: 'members-cleanup',
                    component: () => import('./components/members/CleanUp.vue')
                },
                {
                    path: '/members-cleanup',
                    name: 'members-cleanup',
                    component: () => import('./components/members/CleanUp.vue')
                },
                {
                    path: '/members-spam-filter',
                    name: 'members-spam-filter',
                    component: () => import('./components/members/spam-filter/All.vue')
                },
                {
                    path: '/members-spam-filter-add',
                    name: 'members-spam-filter-add',
                    component: () => import('./components/members/spam-filter/Add.vue')
                },
                {
                    path: '/report-recipients',
                    name: 'site-reports-recipients',
                    component: () => import('./components/reports/ManageRecipients.vue')
                },
                {
                    path: '/notifications',
                    name: 'site-notifications',
                    component: () => import('./components/reports/Notifications.vue')
                },
                {
                    path: '/plausible-dashboard',
                    name: 'plausible-dashboard',
                    component: () => import('./components/reports/PlausibleReports.vue')
                },
                {
                    path: '/outpost-dashboard',
                    name: 'outpost-dashboard',
                    component: () => import('./components/reports/OutpostReports.vue')
                },
                {
                    path: '/events-log',
                    name: 'site-events-log',
                    component: () => import('./components/reports/EventsLog.vue')
                },
                {
                    path: '/sponsorship-boxes',
                    name: 'sponsorship-boxes',
                    component: () => import('./components/sponsor-box/All.vue')
                },
                {
                    path: '/sponsorship-box-add',
                    name: 'sponsorship-box-add',
                    component: () => import('./components/sponsor-box/Add.vue')
                },
                {
                    path: '/email-templates',
                    name: 'email-templates',
                    component: () => import('./components/email-settings/EmailTemplates.vue')
                },
                {
                    path: '/email-template-add',
                    name: 'email-template-add',
                    component: () => import('./components/email-settings/EmailTemplatesAdd.vue')
                },
                {
                    path: '/email-template-add/:actionName/:tierId',
                    name: 'email-template-add-action',
                    component: () => import('./components/email-settings/EmailTemplatesAdd.vue')
                },
                {
                    path: '/email-template-edit/:templateId',
                    name: 'email-template-edit',
                    component: () => import('./components/email-settings/EmailTemplatesEdit.vue')
                },
                {
                    path: '/email-template-settings',
                    name: 'email-template-settings',
                    component: () => import('./components/email-settings/EmailTemplateSettings.vue')
                },
                {
                    path: '/tip-jar',
                    name: 'tip-jar',
                    component: () => import('./components/tips/TipButton.vue')
                },
                {
                    path: '/buttons-wizard',
                    name: 'site-buttons-wizard',
                    component: () => import('./components/blog/ButtonsWizard.vue')
                },
                {
                    path: '/plans',
                    name: 'site-plans',
                    component: () => import('./components/subscriptions/Plans.vue')
                },
                {
                    path: '/default-plans',
                    name: 'site-default-plans',
                    component: () => import('./components/subscriptions/DefaultPlans.vue')
                },
                {
                    path: '/offers',
                    name: 'site-offers',
                    component: () => import('./components/subscriptions/Offers.vue')
                },
                {
                    path: '/promotions',
                    name: 'promotions',
                    component: () => import('./components/subscriptions/promotions/All.vue'),
                },
                {
                    path: '/promotion-add',
                    name: 'promotion-add',
                    component: () => import('./components/subscriptions/promotions/Add.vue'),
                },
                {
                    path: '/one-person-subscriptions',
                    name: 'site-one-person-subscriptions',
                    component: () => import('./components/subscriptions/one-time-subscription/Main.vue'),
                },
                {
                    path: '/create-subscription/:email?',
                    name: 'create-subscription',
                    component: () => import('./components/subscriptions/one-time-subscription/Main.vue'),
                },
                {
                    path: '/institutional-subscriptions',
                    name: 'site-institutional-subscriptions',
                    component: () => import('./components/subscriptions/InstitutionalSubscriptions.vue'),
                },
                {
                    path: '/group-subscriptions',
                    name: 'site-group-subscriptions',
                    component: () => import('./components/subscriptions/group-subscriptions/List.vue'),
                },
                {
                    path: '/gift-subscriptions-settings',
                    name: 'gift-subscriptions-settings',
                    component: () => import('./components/subscriptions/GiftSubscriptionsSettings.vue'),
                },
                {
                    path: '/autoresponder',
                    name: 'site-autoresponder',
                    component: () => import('./components/autoresponder/Actions.vue'),
                },
                {
                    path: '/autoresponder-settings',
                    name: 'site-autoresponder-settings',
                    component: () => import('./components/autoresponder/Settings.vue'),
                },
                {
                    path: '/emails-flow',
                    name: 'site-emails-flow',
                    component: () => import('./components/autoresponder/emails-flow/Main.vue'),
                },
                {
                    path: '/retention-flow',
                    name: 'site-retention-flow',
                    component: () => import('./components/autoresponder/retention-flow/Main.vue'),
                },
                {
                    path: '/cta',
                    name: 'site-cta',
                    component: () => import('./components/cta/Index.vue'),
                },
                {
                    path: '/theme-connect-wizard',
                    name: 'site-theme-connect-wizard',
                    component: () => import('./components/theme-connect-wizard/Main.vue'),
                },
                // signup routes

                {
                    path: '/onboard-flow',
                    name: 'onboard-flow',
                    component: () => import('./components/signup/OnboardFlow.vue'),
                },
                {
                    path: '/onboard-flow-final',
                    name: 'onboard-flow-final',
                    component: () => import('./components/signup/OnboardFlow.vue'),
                    props: { curStep: 'stepFinal' }
                },
                {
                    path: '/connection-wizard',
                    name: 'connection-wizard',
                    component: () => import('./components/signup/ConnectionWizardGhost.vue'),
                },
                {
                    path: '/connection-wizard-stripe',
                    name: 'connection-wizard-stripe',
                    component: () => import('./components/signup/ConnectionWizardStripe.vue'),
                },
                {
                    path: '/connection-wizard-tiers',
                    name: 'connection-wizard-tiers',
                    component: () => import('./components/signup/ConnectionWizardCreateGhostTiers.vue'),
                },
                {
                    path: '/posts-trending',
                    name: 'posts-trending',
                    component: () => import('./components/posts/Trending.vue'),
                },
                {
                    path: '/gated-pdf',
                    name: 'gated-pdf',
                    component: () => import('./components/gated-pdf/All.vue')
                },
                {
                    path: '/gated-pdf-add',
                    name: 'gated-pdf-add',
                    component: () => import('./components/gated-pdf/Add.vue')
                },
                {
                    path: '/posts-paywall',
                    name: 'posts-paywall',
                    component: () => import('./components/posts-paywall/Index.vue')
                },
                {
                    path: '/posts-events',
                    name: 'posts-events',
                    component: () => import('./components/posts-event/All.vue')
                },
                {
                    path: '/posts-event-add',
                    name: 'posts-event-add',
                    component: () => import('./components/posts-event/Add.vue')
                },
                {
                    path: '/ad-tool',
                    name: 'ad-tool',
                    component: () => import('./components/ad-tool/Index.vue')
                },
                {
                    path: '/demo-posts',
                    component: () => import('./components/blog/demo-posts/DemoPosts.vue')
                },
                {
                    path: '/email-campaigns',
                    name: 'email-campaigns',
                    component: () => import('./components/autoresponder/email-campaign/All.vue')
                },
                {
                    path: '/email-campaign-add',
                    name: 'email-campaign-add',
                    component: () => import('./components/autoresponder/email-campaign/Add.vue')
                },
                {
                    path: '/subscription-schedules',
                    name: 'subscription-schedules',
                    component: () => import('./components/subscriptions/schedules/All.vue')
                },
                {
                    path: '/subscription-schedule-add',
                    name: 'subscription-schedule-add',
                    component: () => import('./components/subscriptions/schedules/Add.vue')
                },

                {
                    path: "/:catchAll(.*)",
                    redirect: '/',
                },
            ]
        },
    ]
});

export default router;
